import React from 'react';
import { FormattedMessage } from 'react-intl';
import PrevSearchButton from '../SearchBar/PrevSearchButton';

function UMONoItemFound() {
  return (
    <div className='umo-empty-placeholder'>
      <div className='umo-empty-placeholder__bg' />
      <div className='umo-empty-placeholder__title'>
        <FormattedMessage id="searchResults.noItemFound" description="No Item Found"  />
      </div>
      <div className='umo-empty-placeholder__back'>
        <PrevSearchButton />
      </div>
    </div>
  );
}

export default UMONoItemFound;